import React, { useEffect, useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import { connect } from "react-redux";

function SelectionListVehicles(props) {
  const [vehicles, setVehicles] = useState({})
  const { initialClick, classes, campaigns, selected, updateSelectedTrucks, updateSelectedTrucksNames, selectedTrucksNames } = props;
  useEffect(() => {
    if(Object.entries(campaigns[selected]?.vehicles).length > 0){
      let newData = Object.keys(campaigns[selected]?.vehicles).reduce((result, key) => {
        if(selectedTrucksNames.length > 0 && !initialClick) {
          result[key] = { ...campaigns[selected]?.vehicles[key], checked: selectedTrucksNames.includes(campaigns[selected]?.vehicles[key]?.name) ? true : false };
        }else if(selectedTrucksNames.length === 0 && !initialClick) {
          result[key] = { ...campaigns[selected]?.vehicles[key], checked:  false };
        }else {
          result[key] = campaigns[selected]?.vehicles[key].name ? { ...campaigns[selected]?.vehicles[key], checked: true } : null;
        }
        return result;
      }, {});
      let newDataWithoutNull = Object.keys(newData).reduce((result, key) => {
        if (newData[key] !== null) {
          result[key] = newData[key];
        }
        return result;
      }, {});
      updateSelectedTrucks(newDataWithoutNull.length)
      setVehicles(newDataWithoutNull)
    }
    return () => {
      setVehicles({})
    }
  }, [selected])

  const updateOnMap = (id, show) => {
    if (show) {
      props.map.setLayoutProperty(id, "visibility", "visible");
    } else {
      props.map.setLayoutProperty(id, "visibility", "none");
    }
  };
  const handleCheckboxChange = (key) => {
    const updatedRow = { ...vehicles[key] };
    updatedRow.checked = !vehicles[key].checked;
    const updatedVehicles = { ...vehicles, [key]: updatedRow };
    const count = Object.values(updatedVehicles).reduce((acc, vehicle) => {
      if (vehicle.checked === true) {
        return acc + 1;
      }
      return acc;
    }, 0);
    const checkedNames = Object.values(updatedVehicles).reduce(
      (acc, vehicle) => {
        if (vehicle.checked === true) {
          acc.push(vehicle.name);
        }
        return acc;
      },
      []
    );
    updateSelectedTrucksNames(checkedNames)
    updateSelectedTrucks(count)
    setVehicles(updatedVehicles);
  };

  const toggle = (e, vehicleId) => {
    let layerId = `vehicle-${vehicleId}`;
    let checked = e.target.checked;
    updateOnMap(layerId, checked);
    handleCheckboxChange(vehicleId); // Call handleCheckboxChange to update the state
  };

  let vehicleTempBoolean = Object.values(vehicles).some(vehicle => {
    return (typeof vehicle === 'object' &&
      vehicle !== null &&
      vehicle.hasOwnProperty('paths'));
  });
  return (
    <List
      className={classes.SelectionList}
      style={{ width: '245px', maxHeight: 'calc(100vh - 350px)', overflow: 'auto'}}
    >
      {!vehicleTempBoolean && (
        <ListItem
        style={{
          background: '#FFFF',
          marginBottom: '2px',
          cursor: 'unset',
          // width: '245px'
        }}
        dense
        button
      >
        No Truck Route To Display
        </ListItem>
      )}
      {vehicleTempBoolean && Object.entries(vehicles)?.length > 0 && Object.entries(vehicles)?.map(([key, vehicle], index) =>  {
        const labelId = `checkbox-list-label-${key}`;
        return (
          <ListItem
            style={{
              borderBottom: index !== Object.entries(vehicles)?.length - 1 ? '1px solid #ffff' : '',
              background: '#FFFF',
              marginBottom: '2px',
              cursor: 'unset',
              // width: '245px'
            }}
            key={key}
            role={undefined}
            dense
            button
          >
            <div style={{ minWidth: 'none'}}>
              <Checkbox
               edge="start" 
               style={{cursor: 'pointer'}}
               tabIndex={-1} 
               checked={vehicle.checked}
               disableRipple 
               onChange={(e) =>{
                toggle(e, key)
                handleCheckboxChange(key)
              }}
               inputProps={{ 'aria-labelledby': labelId }} 
               />
            </div>
            <span style={{fontFamily: 'Poppins'}} id={labelId}>{vehicle.name}</span>
            <div style={{ marginLeft: '10px', height: 20, width: 20, backgroundColor: vehicle.color, borderRadius: '50%' }}></div>
          </ListItem>
        );
      })}
    </List>
  );
}


const mapStateToProps = (state) => {
  return {
    campaigns: state.clientDashboardTemp.campaigns,
    selected: state.clientDashboardTemp.selected,
    map: state.clientDashboardTemp.map
  };
};


export default connect(mapStateToProps)(SelectionListVehicles);